import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      flexDirection: 'column',
    },
    options: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(3),
    },
    title: {
      fontWeight: theme.typography.fontWeightMedium,
    },
    subTitle: {
      fontWeight: theme.typography.fontWeightMedium,
      marginBottom: theme.spacing(1),
    },
    durationSelect: {
      width: '80%',
    },
    durationArea: {
      display: 'flex',
      flexDirection: 'row',
    },
    error: {
      color: theme.palette.error.main,
    },
  }),
);

export default useStyles;
